module.exports = __webpack_public_path__ + "img/pay-logo-mastercard.62b3e66c.svg";